import { createSlice } from '@reduxjs/toolkit';
import { EEmployeeContract } from '../../shared/enums/user/EContract';
import { ECountry } from '../../shared/enums/user/ECountry';
import { EEmployeeType } from '../../shared/enums/user/EEmployeeType';
import { EGender } from '../../shared/enums/user/EGender';
import { EMarital } from '../../shared/enums/user/EMarital';
import { EReligion } from '../../shared/enums/user/EReligion';
import { ERole } from '../../shared/enums/user/ERole';
import { ETheme } from '../../shared/enums/user/ETheme';
import { EWorkmode } from '../../shared/enums/user/EWorkmode';
import { IUser } from '../../shared/interfaces/user/IUser';

export interface IAuthState {
  isAuthenticated: boolean;
  token: string;
  userData?: IUser;
}

const initialState: IAuthState = {
  isAuthenticated: false,
  token: '',
  userData: {
    role: ERole.USER,
    id: 0,
    createdAt: '',
    displayName: '',
    position: '',
    updatedAt: '',
    email: '',
    firstName: '',
    theme: ETheme.LIGHT,
    language: '',
    lastName: '',
    phoneNumber: '',
    birthday: '',
    maritalStatus: EMarital.SINGLE,
    gender: EGender.OTHER,
    religion: EReligion.OTHER,
    address: '',
    city: '',
    country: ECountry.BOSNIA,
    zipCode: '',
    employeeType: EEmployeeType.FULL_TIME,
    workMode: EWorkmode.ONSITE,
    dateOfJoin: '',
    employeeContract: EEmployeeContract.PERMANENT,
    gitHub: '',
    linkedin: '',
    skype: '',
    isEmailNotificationEnabled: true,
    isVerified: false,
    profilePhoto: null,
    departments: [],
    projects: [],
    userDocuments: [],
    unreadNotifications: 0,
  },
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setLoginState: (state, action) => {
      state = action.payload;
      return state;
    },
    setLogoutState: (state) => {
      state = initialState;
      return state;
    },
  },
});

export default authSlice;
